module.exports = __webpack_public_path__ + "img/photo.ed11e88b.svg";